import { call, put } from 'redux-saga/effects';

import { apiRequest } from '../../api/api.saga-services';
import * as api from '../../api/request-config/subscription.api';

import * as actions from './subscription-access.actions';
import * as types from './subscription-access.types';

export function* storeSubscriptionAccess(access: types.ISubscriptionAccess) {
  yield put(actions.storeSubscriptionAccess(access));
  return access;
}

export function* getSubscriptionAccess() {
  const access = (yield call(apiRequest, api.getSubscriptionAccessApi())) as types.ISubscriptionAccess | null;
  if (!access) {
    return null;
  }

  yield call(storeSubscriptionAccess, access);
  return access;
}

export function* clearSubscriptionAccess() {
  yield put(actions.clearSubscriptionAccess());
}
